import { useTranslation } from "react-i18next";
import { useDocumentTitle } from "src/common/utils/hooks/useDocumentTitle.js";
import { DashboardHeader } from "./DashboardHeader.js";

/** No company domain selected — same shell as StartDashboard, minus the widgets that need one. */
export const AllDomainsDashboard = () => {
	const { t } = useTranslation();
	useDocumentTitle(t("Start"));

	return (
		<div className="min-h-full bg-grey-50 p-4 lg:p-6">
			<DashboardHeader />
		</div>
	);
};
